import React from 'react';
import { FileText, Image, File } from 'lucide-react';

export const statusLabels = {
  'RECEBIDA': 'Recebida',
  'EM_TRIAGEM': 'Em Triagem',
  'ADMITIDA': 'Admitida',
  'INADMITIDA': 'Inadmitida',
  'EM_INVESTIGACAO': 'Em Investigação',
  'AGUARDA_INFO': 'Aguarda Informação',
  'PENDENTE_APROVACAO': 'Pendente Aprovação',
  'CONCLUIDA': 'Concluída',
  'ARQUIVADA': 'Arquivada'
};

export const statusColors = {
  'RECEBIDA': 'bg-slate-100 text-slate-700',
  'EM_TRIAGEM': 'bg-blue-100 text-blue-700',
  'ADMITIDA': 'bg-sky-100 text-sky-700',
  'INADMITIDA': 'bg-red-100 text-red-700',
  'EM_INVESTIGACAO': 'bg-purple-100 text-purple-700',
  'AGUARDA_INFO': 'bg-amber-100 text-amber-700',
  'PENDENTE_APROVACAO': 'bg-orange-100 text-orange-700',
  'CONCLUIDA': 'bg-emerald-100 text-emerald-700',
  'ARQUIVADA': 'bg-gray-100 text-gray-500'
};

export const severityOptions = ['BAIXO', 'MEDIO', 'ALTO', 'CRITICO'];
export const resultOptions = ['PROCEDENTE', 'IMPROCEDENTE', 'PARCIALMENTE_PROCEDENTE'];

export const getFileIcon = (type) => {
  if (type?.startsWith('image/')) return <Image className="w-4 h-4" />;
  if (type?.includes('pdf')) return <FileText className="w-4 h-4" />;
  return <File className="w-4 h-4" />;
};

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const isImageFile = (contentType) => contentType?.startsWith('image/');

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('pt-PT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const getDaysRemaining = (deadline) => {
  if (!deadline) return null;
  const diff = new Date(deadline) - new Date();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};
